/* eslint-disable */
import { mapActions, mapGetters, mapState } from 'vuex';
import Contract from '@/models/contract';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import marketSharesBar from '@/components/market/market-shares-bar/market-shares-bar.vue';
import buttonPrice from '@/components/market/v2/button-price/button-price.vue';
import {
  isMarketSingle, isMarketSettled, isMarketDisabled, isMarketJourneyDisabled,
  contractOwnershipNum,
} from '@/utils/helpers'
import accountVerifyMixin from '@/mixins/accountVerify';
import marketDisabledOutcomeV2
  from '@/components/market/v2/market-disabled-outcome-v2/market-disabled-outcome-v2.vue';
import marketTradingUnavailableV2 from '@/components/market/v2/market-trading-unavailable-v2/market-trading-unavailable-v2.vue';
import { OPERATIONS, VALUES, BUTTONS, getActiveButtonAfterSwitch, thousandDisplay } from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi.js';
import { BOTTOM_WIDGET_FOOTER_MODES } from '@/store/modules/trade';
import scrollTo from '@/utils/scrollTo'


export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    buttonPrice,
    marketChangePrice,
    marketSharesBar,
    marketDisabledOutcomeV2,
    marketTradingUnavailableV2,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    contract: {
      type: Object,
      required: true,
    },
    forCmsWidget: {
      type: Boolean,
      default: false,
    },
    dashboardMode: {
      type: Boolean,
      default: false,
    },
    dontShowOdds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: false,
      BUTTONS,
      OPERATIONS,
      VALUES,
      isWaiting: false,
      activeButton: BUTTONS.BUY_YES.id,
      chart: null,
    };
  },
  mounted() {
    this.initializePurchaseButtons();
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode', 'hidePurchaseForContractId']),
    ...mapState('user', ['status']),
    ...mapState('app', ['showOdds']),
    shouldApplyOddsLogic() {
      // dontShowOdds can be explicilty set in props thats more important than showOdds from state
      return this.showOdds && !this.dontShowOdds;
    },
    hideButtons() {
      return this.isLayoutMobile && this.shouldApplyOddsLogic && !this.isMarketDisabled && (!this.isContractActive || this.hidePurchaseForContractId === this.contract.contractId);
    },
    isContractActive() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId
    },
    tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue,
      };
    },
    contractModel() {
      return new Contract(this.contract);
    },
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    singleMarketTitle() {
      return this.isMarketSingle ?
        this.market.marketShortName :
        (this.contractModel.contractName || this.contractModel.name);
    },
    title() {
      return this.isMarketSingle ?
        this.singleMarketTitle :
        (this.contractModel.contractName || this.contractModel.name);
    },
    classModifiers() {
      return {
        'market-contract-horizontal-sushi-common-betslip': true,
        'market-contract-horizontal-sushi-common-betslip--disabled': this.isMarketDisabled,
        'market-contract-horizontal-sushi-common-betslip--hovered': this.hovered,
        'market-contract-horizontal-sushi-common-betslip--settled': this.isMarketSettled,
        'market-contract-horizontal-sushi-common-betslip--settled-yes': this.isMarketSettled && this.isWinnerYes,
        'market-contract-horizontal-sushi-common-betslip--settled-no': this.isMarketSettled && this.isWinnerNo,
        'market-contract-horizontal-sushi-common-betslip--should-close': this.isContractActive,
      };
    },
    imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
    openOffersText() {
      const buyOffers = thousandDisplay(this.contractModel.userOpenOrdersBuyQuantity, false);
      const sellOffers = thousandDisplay(this.contractModel.userOpenOrdersSellQuantity, false);
      // const prefix = (this.isLayoutDesktop && !this.isLayoutDashboard) ? 'Offers: ' : '';
      return `${buyOffers}/${sellOffers}`;
    },
    showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    showSharesBarTop() {
      return this.showSharesBar && !this.isMarketDisabled;
    },
    showSharesBarBottom() {
      return this.showSharesBar && this.isMarketDisabled;
    },
    isMarketDisabled() {
      return isMarketDisabled(this.market);
    },
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    isMarketJourneyDisabled() {
      return isMarketJourneyDisabled(this.market);
    },
    currentPriceSymbol() {
      if (this.dontShowOdds) return '&cent;';
      return this.showOdds ? '%' : '&cent;';
    },
    currentPrice() {
      return this.contractModel.lastTradePriceAsCentsWithZeroBypass;
    },
    isWinnerYes() {
      return this.contract.settledStatus === 1;
    },
    isWinnerNo() {
      return this.isMarketSingle && this.contract.settledStatus === 2;
    },
  },
  watch: {
    // isContractActive(value) {
    //   if (this.isLayoutDesktop) {
    //     if (!value) {
    //       this.activeButton = BUTTONS.BUY_YES.id;
    //     }
    //   }
    // },
    'tradeOperationAndValue' (v) {
      if (this.contract.contractId !== this.tradeOptions.contractId) {
        return;
      }
      const { type, value } = v;
      if (type && value) {
        this.activeButton = value === VALUES.YES ? BUTTONS.BUY_YES.id : BUTTONS.BUY_NO.id;
      }
    },
    tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      const button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
    },
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'toggleTradeOperation', 'toggleHidePurchaseForContractId', 'setBottomBetSlipExtendedMode', 'setBottomWidgetFooterMode']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('market', ['pushSessionHistoryContract']),
    findActiveButton() {
      return Object.values(BUTTONS).find(i => i.id === this.activeButton);
    },
    getTypeAndValueIfButtonActiveOrDefaults() {
      let type = this.tradeOptions.operationType;
      let value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        const button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type, value };
    },
    onClickOpenOffers() {
      let tab = 'sell-offers';
      const operationType = this.tradeOptions.operationType || '';
      if (
        (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity) ||
        (operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity)
      ) {
        tab = 'buy-offers';
      }
      const { type, value } = this.getTypeAndValueIfButtonActiveOrDefaults();
      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons() {
      let button = BUTTONS.BUY_YES;
      if (this.contractModel.mode === VALUES.NO) {
        button = (this.contract.contractId === this.tradeOptions.contractId && this.tradeOptions.operationValue === 'no') ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      } else if (this.contractModel.mode === VALUES.YES) {
        button = BUTTONS.BUY_YES;
      }
      if (
        (!this.isMarketSingle || this.isLayoutMobile) &&
        this.tradeOptions &&
        (this.contract.contractId === this.tradeOptions.contractId) &&
        (
          button.type !== this.tradeOptions.operationType
          || button.value !== this.tradeOptions.operationValue
        )
      ) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave() {
      this.hovered = false;
    },
    onContractClick() {
      if (this.isContractActive && this.isLayoutMobile) {
        if (this.dashboardMode) {
          this.setTradeOptions(null);
          return;
        } else {
          this.setBottomWidgetFooterMode(BOTTOM_WIDGET_FOOTER_MODES.BETSLIP);
          this.setBottomBetSlipExtendedMode(false);
        }
      }

      if (this.tradeOptions.contractId !== this.contract.contractId) {
        if (this.activeButton) {
          let button = BUTTONS.BUY_YES;
          if (this.contractModel.mode) {
            button = (this.contractModel.mode === VALUES.NO) ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
          }
          this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, true);
        } else {
          const button = (this.contractModel.mode === VALUES.NO) ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
          this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, true);
        }
      } else {
        this.toggleHidePurchaseForContractId(this.contractModel.contractId);
      }
    },
    isButtonActiveClassModifiers(index) {
      const isOn = this.activeButton === index;

      return {
        'market-contract-horizontal-sushi-common-betslip__button-single--active': this.isContractActive,
        'market-contract-horizontal-sushi-common-betslip__button-single--on': isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off': !isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off-yes': (this.tradeOptions.operationValue === VALUES.YES),
        'market-contract-horizontal-sushi-common-betslip__button-single--off-no': (this.tradeOptions.operationValue === VALUES.NO),
      };
    },
    openPurchaseJourney(
      contractId, operationType, operationValue, dontExtendMobileBetslip = false
    ) {
      if (this.isWaiting) {
        return;
      }

      // this.isWaiting = true;
      // waitForFirebaseInitialized()
      //   .then(() => {
      //   if (this.isLoggedIn) {
      //     return waitForStatusReady();
      //   }
      //   return Promise.resolve(1);
      // })
      //   .then(() => {
      //
      //   });

      this.isWaiting = false;
      // contract does not modify tradeOptions, is simply used as a widget somewhere
      if (this.forCmsWidget) {
        this.$emit('contractClicked', { contractId });
        return;
      }
      // if (this.isLoggedIn && !this.isUserVerified) {
      //   this.showAccountVerifyPopup();
      //   return;
      // }
      // if (this.isLoggedIn && !this.status.hasBeenFunded) {
      //   this.showAddFundsPopup({ delay: false });
      //   return;
      // }
      if (this.isMarketJourneyDisabled || (this.isMarketDisabled && contractOwnershipNum(this.contractModel) === 0)) return;

      this.pushSessionHistoryContract({
        value: {
          ...this.contract,
          marketName: this.market.marketShortName || this.market.marketName
        }
      });
      this.setTradeOptions({
        contractId,
        operationType,
        operationValue: operationValue !== null ?
          operationValue :
          (this.contractModel.mode || VALUES.YES),
      });
      if (!dontExtendMobileBetslip) {
        this.setBottomWidgetFooterMode(BOTTOM_WIDGET_FOOTER_MODES.BETSLIP);
        this.setBottomBetSlipExtendedMode(true);
      }
      if (this.dashboardMode) {
        setTimeout(() => {
          const $el = document.querySelector(`[data-contract-id="${contractId}"]`);
          if ($el === null) return;
          const destination = Math.max(0, $el.offsetTop);
          scrollTo(destination, 250, 'linear');
        }, 1000);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contract-horizontal-sushi-common-betslip/market-contract-horizontal-sushi-common-betslip.js